import { render, staticRenderFns } from "./ProductsModelComboboxField.vue?vue&type=template&id=5a2b2c44"
import script from "./ProductsModelComboboxField.vue?vue&type=script&lang=ts"
export * from "./ProductsModelComboboxField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports